"use client";

import Icon from "@/components/icons/Icons";
import { closeModal } from "@/redux/features/GoldInvestModal/goldInvestModalSlice";
import { useRef } from "react";
import { useDispatch } from "react-redux";

type Step = {
  id: number;
  label: string;
};

type StepProgressMobileProps = {
  steps: Step[];
  currentStep: number;
  onStepChange?: (step: number) => void;
  allowBackwardClick?: boolean;
  allowForwardClick?: boolean;
  className?: string;
};

export default function StepProgressMobile({ steps, currentStep, onStepChange, allowBackwardClick = true, allowForwardClick = false, className }: StepProgressMobileProps) {
  const containerRef = useRef<HTMLDivElement | null>(null);
  const dispatch = useDispatch();

  const handleStepClick = (stepId: number) => {
    if (stepId === currentStep) return;

    const isForward = stepId > currentStep;
    const isBackward = stepId < currentStep;

    if (isForward && !allowForwardClick) return;

    if (isBackward && !allowBackwardClick) return;

    onStepChange?.(stepId);
  };

  return (
    <>
      <div className={`flex items-center justify-between mx-auto gap-2.5 max-w-210.5 ${className}`}>
        <div ref={containerRef} className="flex items-center gap-2 w-full">
          {steps.map((step) => {
            const isActive = currentStep === step.id;
            const isCompleted = currentStep > step.id;

            return (
              <div key={step.id} className="relative cursor-pointer w-full max-w-52" onClick={() => handleStepClick(step.id)}>
                <div className={`relative flex items-center justify-center border gap-1.5 xs:gap-3 px-3 py-2 rounded-lg ${isCompleted ? "border-secondaryGreen bg-[#20D60033]" : "border-white bg-white/20"}`}>
                  {/* Left icon */}
                  {isCompleted && (
                    <div className="h-5 w-5 shrink-0 rounded-full bg-secondaryGreen flex items-center justify-center">
                      <Icon.rightSignIcon className="h-3 w-3 text-white" />
                    </div>
                  )}

                  {/* Label */}
                  <span className={`text-sm xs:text-base ${isCompleted || isActive ? "text-white font-medium" : "text-gray-300"}`}>{step.label}</span>
                </div>
              </div>
            );
          })}
        </div>

        <button onClick={() => dispatch(closeModal())} aria-label="Close Popup" className="shrink-0 w-10 h-10 bg-[#FFFFFF33] rounded-full hidden xs:flex items-center justify-center">
          <Icon.popupCloseIcon className="w-5 h-5 text-white rotate-45" />
        </button>
      </div>
    </>
  );
}
